import { Typography, Divider, Select } from 'antd';
import React, { Fragment, ReactElement } from 'react';

import classes from './HomeActivityHeader.module.css';

interface HomeActivityHeaderProps {
  onActivityOptionChange?: (value: string) => void;
  options?: string[];
  selectedActivityOption?: string;
  showDivider?: boolean;
}

function HomeActivityHeader({
  onActivityOptionChange,
  options = [],
  selectedActivityOption,
  showDivider = true,
}: HomeActivityHeaderProps): ReactElement {
  return (
    <Fragment>
      <Divider className={showDivider ? classes.marginTop : classes.hidden} />
      <div className={classes.flexContainer}>
        <Typography.Text strong>Activity</Typography.Text>
        <Select
          className={classes.select}
          value={selectedActivityOption}
          onChange={onActivityOptionChange}
          options={options.map((option) => ({
            value: option,
            label: option,
          }))}
        />
      </div>
    </Fragment>
  );
}

export default HomeActivityHeader;
